import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import { Const } from '@app/shared/util/constants';

@Injectable()
export class ProcedureStatusDataService {
  PATH_SERVICES = Const.ROUTES_SYSTEM_INTEGRATIONS.cinco.services;
  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) {}

  /**
   * Consulta de todos los reportes
   *
   * @returns {Observable<any[]>}
   * @memberof ProcedureStatusDataService
   */
  getStatus(): Observable<any[]> {
    return new Observable(obs => {
      this.http.get<any[]>(this.api.get('statusExpediente')).subscribe(
        status => {
          if (status && status.length) {
            status.sort((a, b) => a.id - b.id);
          }
          obs.next(status);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  

  /**
   * Actualiza un reporte
   *s
   * @param {Reporte} data
   * @returns {Observable<boolean>}
   * @memberof ProcedureStatusDataService
   */
  changeStatus(data: FormData): Observable<boolean> {
    const path = this.PATH_SERVICES + Const.ROUTES_SYSTEM_INTEGRATIONS.cinco.endpoints.utilityStatusProcedure;
    return new Observable(obs => {
      this.http.post<boolean>(this.api.addParams(path, 'simple', []), data).subscribe(
        status => {
          this.toastr.success('Estado modificado con éxito', 'Operación exitosa');
          obs.next(true);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/procedure-status-utility/shared/procedure-status-utility.data.service.ts